import { useState } from "react";
import { firestoreService } from "~/services/firestore-service";
import { useGameStore } from "~/state/game-store";
import { Button } from "~/ui/system/button";
import { Dialog } from "~/ui/system/dialog";
import { MetalWrapper } from "~/ui/system/metal-wrapper";
import { toast } from "~/ui/system/toast";

export function LoginPanel() {
  const [username, setUsername] = useState<string>("");
  const setUser = useGameStore((s) => s.setUser);
  const setOpenMenu = useGameStore((s) => s.setOpenMenu);

  const handleConfirm = async () => {
    try {
      const user = await firestoreService.createUser(username);
      await setUser(user);
      setOpenMenu(null);
      toast.success("Logged in as: " + username);
    } catch (err) {
      toast.error((err as Error).message);
    }
  };

  const onCancel = () => {
    setOpenMenu(null);
  };

  return (
    <Dialog onClose={onCancel}>
      <MetalWrapper variant="solid" size="md" className="max-w-md w-full">
        <h2 className="text-2xl font-bold text-cyan-400 mb-4">
          Create a new Player ID
        </h2>
        {/* <p className="text-gray-300 mb-2">Confirm your Player ID:</p> */}
        <input
          type="text"
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
          }}
          placeholder="Your Player ID"
          className="w-full bg-gray-900 border-2 border-gray-600 rounded px-4 py-2 text-white mb-4 focus:outline-none focus:border-cyan-400"
        />
        <div className="flex gap-4">
          <Button
            onClick={handleConfirm}
            className="flex-1"
            disabled={!username.trim()}
          >
            Confirm
          </Button>
          <Button variant="secondary" onClick={onCancel} className="flex-1">
            Cancel
          </Button>
        </div>
      </MetalWrapper>
    </Dialog>
  );
}
